import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

import forms from './forms';
import login from './login';
import corporate from './corporate/home';
import help from './corporate/help';
import profile from './corporate/profile';
import _profile from './individual/profile';
import individual from './individual/home';
import bes from './individual/bes';
import robo from './individual/robo';
import insurance from './individual/insurance';

const routes = [
	{
		path: '/',
		redirect: {
			name: 'login'
		}
	},
	...login,
	forms,
	...corporate,
	...profile,
	..._profile,
	...help,
	individual,
	...bes,
	insurance,
	...robo
]

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes,
	scrollBehavior(to, from, savedPosition) {
		return new Promise((resolve) => {
			setTimeout(() => {
				if (savedPosition) {
					resolve(savedPosition)
				} else {
					resolve({ x: 0, y: 0 })
				}
			}, 500)
		})
	}
})

export default router
